<template>
  <!-- ========================= -->
  <!-- TAB: IMAGE                -->
  <!-- ========================= -->
  <div>
    <div class="row mt-3 mb-3"></div>
    <div v-if="hasItemName">
      <!-- -------------- -->
      <!-- image          -->
      <!-- -------------- -->
      <div class="form-group text-center">
        <div class="form-floating mb-2">
          <img
            :src="image"
            class="img-fluid w-75 rounded border border-dark bb-image-container"
            alt="item image"
          />
        </div>
        <label
          v-if="showChangeImage"
          class="btn btn-dark btn-file mb-2 bb-click-label"
        >
          Change Image
          <input
            type="file"
            accept="image/*"
            style="display: none"
            name="image"
            ref="selectImage"
            id="selectImage"
            @change="onPreviewImage"
          />
        </label>
        <button
          v-if="showClearImage"
          type="button"
          class="btn btn-dark mb-2 ms-4 bb-click-label"
          @click="onClearImage"
        >
          Clear Image
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemImageTab',
  props: {
    hasItemName: {
      type: Boolean,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    showChangeImage: {
      type: Boolean,
      required: true,
    },
    onPreviewImage: {
      type: Function,
      required: true,
    },
    showClearImage: {
      type: Boolean,
      default: false,
    },
    onClearImage: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
